import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { CommunityLogo } from "@common";
import { NavMenu, useNavMenu } from "@components";
import { useHeader } from "./headers";

interface PageHeaderProps {
    id?: string;
    className?: string;
    communityShortName?: string; // Used by Storybook
}

const PageHeader: React.FC<PageHeaderProps> = ({ id, className, communityShortName }) => {
    const navigate = useNavigate();
    const { showMenu } = useNavMenu();
    const { navigateHome } = useHeader();

    return (
        <header id={id} className={classNames(
            `flex flex-row px-4 py-2.5 md:px-8 md:py-4 items-center md:items-end justify-between bg-white border-b border-neutral-100 w-full h-[60px] md:h-24`,
            className
        )}>
            <CommunityLogo
                className="h-10 md:h-16"
                onClick={navigateHome ? () => navigate(`/`) : undefined}
                communityShortName={communityShortName}
            />
            {showMenu && <NavMenu />}
        </header>
    );
};

export default PageHeader;
